import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    airtable_config_get_label,
    detail_click,
    signup_click,
    toggle_info
} from "../redux/actions";
import {CardsEmpty} from "./CardsEmpty";
import svg1 from '../images/label-1.svg'
import svg2 from '../images/label-2.svg'
import svg3 from '../images/label-3.svg'

export const Cards = () => {
    const dispatch = useDispatch()
    const translate = useSelector(state => state.app.translate)
    let brands = useSelector(state => state.app.brands)
    const search = useSelector(state => state.app.search)
    const aircategories = useSelector(state => state.app.aircategories)
    const current_category = useSelector(state => state.app.current_category)
    const mobile_tracking = useSelector(state => state.app.mobile_tracking)
    const exclusive = useSelector(state => state.app.exclusive)
    const hot_deal = useSelector(state => state.app.hot_deal)
    const subscribe_type = useSelector(state => state.app.subscribe_type)
    const subscribed_brands = useSelector(state => state.app.subscribed_brands)
    const app_lang = useSelector(state => state.app.app_lang)
    const showInfo = useSelector(state => state.app.showInfo)
    const airconfig = useSelector(state => state.app.airconfig)
    const current_page = useSelector(state => state.app.current_page)

    const label1 = airtable_config_get_label(airconfig, 'mobile_tracking_label', app_lang);
    const hint1 = airtable_config_get_label(airconfig, 'mobile_tracking_hint', app_lang);
    const label2 = airtable_config_get_label(airconfig, 'travelpayouts_exclusive_label', app_lang);
    const hint2 = airtable_config_get_label(airconfig, 'travelpayouts_exclusive_hint', app_lang);
    const label3 = airtable_config_get_label(airconfig, 'hot_deal_label', app_lang);
    const hint3 = airtable_config_get_label(airconfig, 'hot_deal_hint', app_lang);

    const join_link = (brand_id, subscribe_type, subscribed_brands, locale) => {
        const client_id = 'b0e02fcc-0ab4-4b2c-a164-742762783a4e';
        if (subscribe_type === 2) {
            const is_subscribed = (subscribed_brands.indexOf(parseInt(brand_id)) > -1);
            if (is_subscribed) {
                return 'https://app.travelpayouts.com/programs/' + brand_id + '/about&locale=' + locale;
            } else {
                return 'https://app.travelpayouts.com/programs/' + brand_id + '/about?from_landing=true&locale=' + locale;
            }
        } else {
            return 'https://passport.travelpayouts.com/registration?&client_id=' + client_id + '&response_type=code&redirect_uri=https%3A%2F%2Fapp.travelpayouts.com%2Fapi%2Fauth%2Fcallback&scope=offline_access&locale=' + locale + '&return_path=https%3A%2F%2Fapp.travelpayouts.com%2Fprograms%2F' + brand_id + '%2Fabout%3Ffrom_landing%3Dtrue%26locale%3D' + locale;
        }
    }
    let brands_out_count = 0;
    let page_brands = (current_page !== null && current_page.brands !== undefined && current_page.brands.length > 0) ? current_page.brands.split(',') : [];
    for (let i = 0; i < brands.length; i++) {
        let item = brands[i];
        let show = true;
        if (search.length >= 1) {
            if (!(item.shortName.toLowerCase().indexOf(search.toLowerCase()) + 1 > 0)) {
                show = false;
            }
        }
        if (page_brands.length > 0) {
            if ((page_brands.indexOf(item.id.toString()) === -1)) {
                show = false;
            }
        } else {
            if (current_category !== '' && item.categories.length > 0) {
                let searchedCategory = false;
                item.categories.forEach((cat) => {
                    aircategories.forEach((subcat) => {
                        if (parseInt(cat.id) === parseInt(subcat.fields.id)) {
                            if (current_category === subcat.fields.slug) {
                                searchedCategory = true;
                            }
                        }
                    })
                })
                if (!searchedCategory) {
                    show = false;
                }
            }
        }
        if (mobile_tracking === true && item.appTracking !== true) {
            show = false;
        }
        if (exclusive === true && item.offerParamsSet.exclusive !== true) {
            show = false;
        }
        if (hot_deal === true && item.offerParamsSet.hot !== true) {
            show = false;
        }
        brands[i].show = show;
        if (show) {
            brands_out_count++;
        }
    }
    useEffect(() => {
        if (brands_out_count === 0 && showInfo) {
            dispatch(toggle_info(false));
        }
        if (brands_out_count > 0 && !showInfo) {
            dispatch(toggle_info(true));
        }
        if (search.length > 0) {
            if (brands_out_count > 0) {
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'eventId': 'd-v4-4',
                    'eventCategory': 'Brands Directory',
                    'eventAction': 'search',
                    'eventLabel': 'brandsDirectory_search_result',
                    'nonInteraction': false
                });

                window.dataLayer.push({
                    'event': 'GA4Event',
                    'eventId': 'd-v4-4',
                    'eventName': 'brandsDirectory_search_result'
                });

            } else {
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'eventId': 'd-v4-5',
                    'eventCategory': 'Brands Directory',
                    'eventAction': 'search',
                    'eventLabel': 'brandsDirectory_search_empty',
                    'nonInteraction': false
                });

                window.dataLayer.push({
                    'event': 'GA4Event',
                    'eventId': 'd-v4-5',
                    'eventName': 'brandsDirectory_search_empty'
                });

            }
        }
    }, [dispatch, brands_out_count, showInfo, search]);

    let temp_brands = [];
    for (let i = 0; i < brands.length; i++) {
        if (brands[i].offerParamsSet.promoPictureUrl !== null) {
            temp_brands[temp_brands.length] = brands[i];
        }
    }
    for (let i = 0; i < brands.length; i++) {
        if (!(brands[i].offerParamsSet.promoPictureUrl !== null)) {
            temp_brands[temp_brands.length] = brands[i];
        }
    }
    brands = temp_brands;

    return (
        <div className="cards">
            {
                brands.length > 0 && brands.map((item) => {
                    if (!item.show) {
                        return null;
                    }
                    let item_class = 'cards__item';
                    if (item.offerParamsSet.promoPictureUrl !== null) {
                        item_class += ' cards__item-promo'
                    }
                    let label_number = 0;
                    if (item.offerParamsSet.hot === true) {
                        label_number = 3;
                    } else {
                        if (item.offerParamsSet.exclusive === true) {
                            label_number = 2;
                        } else {
                            if (item.appTracking === true) {
                                label_number = 1;
                            }
                        }

                    }
                    return (
                        <div key={`card${item.id}`} className={item_class} id={`item-${item.id}`}
                             style={{borderColor: item.offerParamsSet.promoBorderColor}}>
                            <div className="cards__box">
                            <div className="cards__labels">
                                {
                                    label_number === 1 && (
                                        <div className="cards__mobile_tracking">
                                            {label1} <img src={svg1} alt=""/>
                                            {
                                                hint1 && (
                                                    <div className="cards__mobile_tracking_message">{hint1}</div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    label_number === 2 && (
                                        <div className="cards__exclusive">
                                            {label2} <img src={svg2} alt=""/>
                                            {
                                                hint2 && (
                                                    <div className="cards__exclusive_message">{hint2}</div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    label_number === 3 && (
                                        <div className="cards__hot_deal">
                                            {label3} <img src={svg3} alt=""/>
                                            {
                                                hint2 && (
                                                    <div className="cards__hot_deal_message">{hint3}</div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </div>

                            {
                                item.landingUrl && (
                                    <a href={item.landingUrl}
                                       onClick={() => detail_click(item.shortName, item.id, item.landingUrl, 'logo')}
                                       className="cards__image" target="_blank" rel="noopener">
                                        <img src={item.iconUrl} alt="" title="" loading="lazy"/>
                                    </a>
                                )
                            }
                            {
                                !item.landingUrl && (
                                    <div className="cards__image">
                                        <img src={item.logoUrl} alt="" title="" loading="lazy"/>
                                    </div>
                                )
                            }
                            <div className="cards__title">{item.shortName}</div>
                            <div className="cards__caption">{item.offerParamsSet.caption}</div>
                            <div className="cards__params">
                                {
                                    item.offerParamsSet.offerParams.length > 0 && (item.offerParamsSet.offerParams.map((p, index) => {
                                        return (
                                            <div className="cards__param" key={index}>
                                                <div>
                                                    {p.value}
                                                    {
                                                        p.description !== null && (<div className="cards__hint">
                                                            <div className="cards__hint_message">{p.description}</div>
                                                        </div>)
                                                    }
                                                </div>
                                                <div title={p.label}>
                                                    {p.label}
                                                </div>

                                            </div>)

                                    }))
                                }
                            </div>
                            <div className="cards__btns">
                                <a href={join_link(item.id, subscribe_type, subscribed_brands, app_lang)}
                                   onClick={() => signup_click('card', item.shortName, item.id)}
                                   className="cards__btn1"
                                   target="_blank" rel="noopener">
                                    {translate.join_btn}
                                </a>
                                {
                                    item.landingUrl && (
                                        <a href={item.landingUrl}
                                           onClick={() => detail_click(item.shortName, item.id, item.landingUrl, 'button')}
                                           className="cards__btn2" target="_blank"
                                           rel="noopener">
                                            {translate.details_btn}
                                        </a>
                                    )
                                }

                            </div>
                            </div>
                            {
                                (item.offerParamsSet.promoPictureUrl !== null) && (
                                    <a href={item.landingUrl}
                                       onClick={() => detail_click(item.shortName, item.id, item.landingUrl, 'button')}
                                       rel="noopener"
                                       target="_blank"
                                       className="cards__promo_picture"><img src={item.offerParamsSet.promoPictureUrl}
                                                                             alt=""
                                                                             title=""/></a>
                                )
                            }
                        </div>
                    )
                })
            }
            {
                brands_out_count === 0 && (
                    <CardsEmpty/>
                )
            }
        </div>
    )
}